import { Injectable } from "@angular/core";
import { LinhaRota } from '@tivic-team/manager-ts/dist/mob/entities/linha/linha-rota.entity';
import { LinhaRotaController } from '../../controllers/mob/linha-rota.controller';
import { LinhaRotaDTO } from '../../model/dtos/mob/linha-rota.dto';
import { ParadaTabelaHorariosDTO } from '../../model/dtos/mob/para-tabela-horarios.dto';
import { ApiService } from "../api-service.interface";
import { LoaderService } from "../loader.service";
import { LinhaRotaSearch } from './linha-rota.search';

@Injectable({
    providedIn: 'root'
})
export class LinhaRotaService implements ApiService<LinhaRota>{

    constructor(
        private _linhaRotaController: LinhaRotaController,
        private _loaderService: LoaderService
    ) { }

    find(search?: LinhaRotaSearch): Promise<LinhaRota[]> {
        this._loaderService.show();
        return this._linhaRotaController.find(search && search.getFilters() || null).finally(() => this._loaderService.hide());
    }

    create(entity: LinhaRota): Promise<LinhaRota> {
        this._loaderService.show();
        return this._linhaRotaController.create(entity).finally(() => this._loaderService.hide());
    }

    update(entity: LinhaRota): Promise<LinhaRota> {
        this._loaderService.show();
        return this._linhaRotaController.update(entity).finally(() => this._loaderService.hide());
    }

    save(entity: LinhaRota): Promise<LinhaRota> {
        if (!entity.cdRota)
            return this.create(entity);

        return this.update(entity);
    }

    get(id: number): Promise<LinhaRota> {
        throw new Error("Method not implemented.");
    }

    getRota(cdLinha: number, cdRota: number): Promise<LinhaRota> {
        this._loaderService.show();
        return this._linhaRotaController.getRota(cdLinha, cdRota).finally(() => this._loaderService.hide());
    }

    async getParadasRota(cdLinha: number, cdRota: number): Promise<Array<ParadaTabelaHorariosDTO>> {
        this._loaderService.show();
        return this._linhaRotaController.getParadasRota(cdLinha, cdRota).finally(() => this._loaderService.hide());
    }

    async getRotasLinha(idLinha: number, cdRota: number): Promise<Array<LinhaRotaDTO>> {
        this._loaderService.show();
        return this._linhaRotaController.getRotasLinha(idLinha, cdRota).finally(() => this._loaderService.hide());
    }

    async remove(cdLinha: number, cdRota: number): Promise<LinhaRota> {
        this._loaderService.show();
        return this._linhaRotaController.remove(cdLinha, cdRota).finally(() => this._loaderService.hide());
    }

    async inactivate(linhaRota: LinhaRota): Promise<LinhaRota> {
        this._loaderService.show();
        return this._linhaRotaController.inactivate(linhaRota).finally(() => this._loaderService.hide());
    }

    async activate(linhaRota: LinhaRota): Promise<LinhaRota> {
        this._loaderService.show();
        return this._linhaRotaController.activate(linhaRota).finally(() => this._loaderService.hide());
    }
}